/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { Component, OnInit, OnDestroy, HostListener, NgZone } from '@angular/core'
import { Router } from '@angular/router';
import { BAppService } from '../service/bApp.service';
import { Http } from '@angular/http';
import { BLoginService } from '../service/bLogin.service';
import { AlertComponent } from '../alertComponent/alert.component';
import { MatDialogRef } from '@angular/material';
import { PubSubService } from '../service/pubSub.service';
import { MatDialog } from '@angular/material';
import { SystemService } from '../service/system.service';

/**
* Model import Example : 
* import { HERO } from '../models/hero.model.ts';
*/

@Component({
  selector: 'bh-login',
  templateUrl: './login.template.html'
})

export class loginComponent implements OnInit {

  userInvalid = false;
  user = {
    'name': '',
    'pass': '',
    'isRemember': false
  };
  dialogRef: MatDialogRef<any>;
  fBRegCompSub;
  isRememberBoolean;
  systemService = new SystemService();
  window;
  isMobileVar: Boolean = true;

  constructor(private router: Router, private bLoginService: BLoginService,
    private http: Http, private bAppService: BAppService, private pubSubService: PubSubService,
    private dialog: MatDialog, private ngZone: NgZone) {
  }

  ngOnInit() {
    this.isMobileVar = this.isMobile();
    if (this.bLoginService.isLoggedIn()) {
      this.ngZone.run(() => {
        this.router.navigate(['/'])
      });
    }
    if (this.systemService.deviceType != 'browser') {
      this.isRememberBoolean = true;
      this.user.isRemember = true;
    }
  }

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event && event.key == 'Enter' && this.user && this.user['name'] && this.user['pass']) {
      this.login();
    }
  }

  login() {
   this.userInvalid = false;
    if (this.user.name && this.user.pass) {
      this.bLoginService.login(this.user.name, this.user.pass, this.user.isRemember).subscribe(response => {
        this.ngZone.run(() => {
          this.router.navigate(['bhive']);
        })
      },error => {
        if (error.error == 'Invalid username and / or password.') {
          this.userInvalid = true;
        }
      });
    } else {
      this.bAppService.openSnackBar('Please enter a Username or Password');
    }
  }

  isMobile() {
    const platform = this.systemService.deviceType;
    if (platform === 'browser') {
      return false;
    }
    return true;
  }

  ngOnDestroy() {
    //this.fBRegCompSub.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/loginComponent/login.component.ts